import React, { useState } from "react";
import "../../Styles/YuvagalamTable.css";
import { useNavigate } from "react-router-dom";
import {
  FaUserFriends,
  FaCheckCircle,
  FaRegClock,
  FaRupeeSign,
  FaSearch,
  FaMapMarkerAlt,
  FaFilter,
  FaSyncAlt,
  FaUserCircle,
  FaCalendarAlt,
  FaEdit,
  FaChevronLeft,
  FaChevronRight,
  FaChild,
  FaHandsHelping,
  FaTimes,
} from "react-icons/fa";

const INITIAL_DATA = [
  {
    id: 1,
    name: "Chikkala Praveen Kumar",
    relation: "S/O Chikkala Ramulu",
    age: "24",
    qualification: "B.Tech",
    amount: "₹3,000",
    village: "Gudluru",
    mandal: "Gudluru",
    date: "16-06-2026",
    status: "Approved",
  },
  {
    id: 2,
    name: "Vanguri Divya Sri",
    relation: "D/O Vanguri Nageswara Rao",
    age: "22",
    qualification: "Degree",
    amount: "₹3,000",
    village: "Ulavapadu",
    mandal: "Ulavapadu",
    date: "28-05-2026",
    status: "Pending",
  },
  {
    id: 3,
    name: "Kolli Bhaskar Rao",
    relation: "S/O Kolli Venkaiah",
    age: "26",
    qualification: "ITI",
    amount: "₹3,000",
    village: "Kandukur",
    mandal: "Kandukur",
    date: "06-04-2026",
    status: "Approved",
  },
];

const AdminYuvagalamTable = () => {
  const navigate = useNavigate();

  const [yuvagalamData, setYuvagalamData] = useState(INITIAL_DATA);

  const [searchTerm, setSearchTerm] = useState("");
  const [mandalFilter, setMandalFilter] = useState("All Mandals");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [editItem, setEditItem] = useState(null);
  const [editForm, setEditForm] = useState(null);

  /* ===================== SEARCH + FILTER LOGIC ===================== */

  const filteredData = yuvagalamData.filter((item) => {
    const matchesSearch =
      searchTerm.trim() === "" ||
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.relation.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesMandal =
      mandalFilter === "All Mandals" || item.mandal === mandalFilter;

    const matchesStatus =
      statusFilter === "All Status" || item.status === statusFilter;

    return matchesSearch && matchesMandal && matchesStatus;
  });

  const handleResetFilters = () => {
    setSearchTerm("");
    setMandalFilter("All Mandals");
    setStatusFilter("All Status");
    setCurrentPage(1);
  };

  const totalEntries = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalEntries / 10));
  const safePage = Math.min(currentPage, totalPages);
  const startIndex = (safePage - 1) * 10;
  const endIndex = startIndex + 10;
  const pageData = filteredData.slice(startIndex, endIndex);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  /* ===================== EDIT LOGIC ===================== */

  const openEditModal = (item) => {
    setEditItem(item);
    setEditForm({ ...item });
  };

  const closeEditModal = () => {
    setEditItem(null);
    setEditForm(null);
  };

  const handleEditChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setYuvagalamData((prev) =>
      prev.map((item) => (item.id === editForm.id ? { ...editForm } : item)),
    );
    closeEditModal();
  };

  return (
    <div className="yv-page">
      {/* ── FIXED HEADER (stays in place while content scrolls) ── */}
      <div className="yv-header">
        <div className="yv-header-left">
          <div className="yv-header-icon">
            <FaUserFriends />
          </div>
          <div>
            <h2 className="yv-title">Yuvagalam Beneficiaries</h2>
            <p className="yv-subtitle">
              Manage and track beneficiaries under Yuvagalam Scheme
            </p>
          </div>
        </div>

        <button
          className="yv-add-btn"
          onClick={() => navigate("/AdminDashboard/YuvagalamForm")}
        >
          <span className="yv-add-plus">+</span> Add New Beneficiary
        </button>
      </div>

      {/* ── SCROLLABLE BODY ── */}
      <div className="yv-scroll-body">
        {/* Stat Cards */}
        <div className="yv-stats-row">
          <div className="yv-stat-card">
            <div className="yv-stat-icon yv-icon-pink">
              <FaUserFriends />
            </div>
            <div>
              <p className="yv-stat-label">Total Beneficiaries</p>
              <h3 className="yv-stat-value">3,240</h3>
              <p className="yv-stat-sub">All time records</p>
            </div>
          </div>

          <div className="yv-stat-card">
            <div className="yv-stat-icon yv-icon-green">
              <FaCheckCircle />
            </div>
            <div>
              <p className="yv-stat-label">Approved Beneficiaries</p>
              <h3 className="yv-stat-value">2,450</h3>
              <p className="yv-stat-sub yv-sub-green">75.6% of total</p>
            </div>
          </div>

          <div className="yv-stat-card">
            <div className="yv-stat-icon yv-icon-orange">
              <FaRegClock />
            </div>
            <div>
              <p className="yv-stat-label">Pending Beneficiaries</p>
              <h3 className="yv-stat-value">790</h3>
              <p className="yv-stat-sub yv-sub-orange">24.4% of total</p>
            </div>
          </div>

          <div className="yv-stat-card">
            <div className="yv-stat-icon yv-icon-purple">
              <FaRupeeSign />
            </div>
            <div>
              <p className="yv-stat-label">Total Amount Disbursed</p>
              <h3 className="yv-stat-value">₹97,20,000</h3>
              <p className="yv-stat-sub yv-sub-purple">All time disbursed</p>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="yv-filter-section">
          <div className="yv-search-wrapper">
            <FaSearch className="yv-search-icon" />
            <input
              type="text"
              placeholder="Search Beneficiary..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="yv-select-wrapper">
            <FaMapMarkerAlt className="yv-select-icon" />
            <select
              value={mandalFilter}
              onChange={(e) => {
                setMandalFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option>All Mandals</option>
              <option>Kandukur</option>
              <option>Gudluru</option>
              <option>Ulavapadu</option>
            </select>
          </div>

          <div className="yv-select-wrapper">
            <FaFilter className="yv-select-icon" />
            <select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option>All Status</option>
              <option>Approved</option>
              <option>Pending</option>
            </select>
          </div>

          <button className="yv-reset-btn" onClick={handleResetFilters}>
            <FaSyncAlt /> Reset Filters
          </button>
        </div>

        {/* Table */}
        <div className="yv-table-wrapper">
          <table className="yv-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Relation</th>
                <th>Age</th>
                <th>Qualification</th>
                <th>Amount</th>
                <th>Village</th>
                <th>Mandal</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {pageData.length > 0 ? (
                pageData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{startIndex + index + 1}</td>
                    <td>
                      <div className="yv-name-cell">
                        <span className="yv-avatar">
                          <FaUserCircle />
                        </span>
                        <span className="yv-name-text">{item.name}</span>
                      </div>
                    </td>
                    <td className="yv-relation-cell">{item.relation}</td>
                    <td>{item.age}</td>
                    <td>{item.qualification}</td>
                    <td className="yv-amount">{item.amount}</td>
                    <td>
                      <span className="yv-village-cell">
                        <FaMapMarkerAlt /> {item.village}
                      </span>
                    </td>
                    <td>{item.mandal}</td>
                    <td>
                      <span className="yv-date-cell">
                        <FaCalendarAlt /> {item.date}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`yv-status ${
                          item.status === "Approved"
                            ? "yv-approved"
                            : "yv-pending"
                        }`}
                      >
                        {item.status === "Approved" ? (
                          <FaCheckCircle />
                        ) : (
                          <FaRegClock />
                        )}{" "}
                        {item.status}
                      </span>
                    </td>
                    <td className="yv-action-cell">
                      <button
                        className="yv-edit-btn"
                        onClick={() => openEditModal(item)}
                      >
                        <FaEdit /> Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="yv-no-data">
                    No matching beneficiaries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer / Pagination */}
        <div className="yv-footer">
          <p className="yv-footer-text">
            {totalEntries > 0
              ? `Showing ${startIndex + 1} to ${Math.min(
                  endIndex,
                  totalEntries,
                )} of ${totalEntries} beneficiaries`
              : "Showing 0 beneficiaries"}
          </p>

          <div className="yv-pagination">
            <button
              className="yv-page-btn"
              onClick={() => goToPage(safePage - 1)}
              disabled={safePage === 1}
            >
              <FaChevronLeft />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
              (page) => (
                <button
                  key={page}
                  className={`yv-page-btn ${
                    safePage === page ? "yv-page-active" : ""
                  }`}
                  onClick={() => goToPage(page)}
                >
                  {page}
                </button>
              ),
            )}

            <button
              className="yv-page-btn"
              onClick={() => goToPage(safePage + 1)}
              disabled={safePage === totalPages}
            >
              <FaChevronRight />
            </button>
          </div>
        </div>

        {/* Scheme Info Banner */}
        <div className="yv-scheme-banner">
          <div className="yv-banner-icon-left">
            <FaChild />
          </div>

          <div className="yv-banner-text">
            <h4>Yuvagalam Scheme</h4>
            <p>
              Providing financial assistance of ₹3,000 to eligible
              unemployed youth to support their career growth and skill
              development.
            </p>
          </div>

          <div className="yv-banner-icon-right">
            <FaHandsHelping />
          </div>
        </div>
      </div>

      {/* ===================== EDIT MODAL ===================== */}
      {editItem && editForm && (
        <div className="yv-modal-overlay" onClick={closeEditModal}>
          <div
            className="yv-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="yv-modal-header">
              <h3>Edit Beneficiary</h3>
              <button className="yv-modal-close" onClick={closeEditModal}>
                <FaTimes />
              </button>
            </div>

            <form className="yv-modal-form" onSubmit={handleEditSave}>
              <div className="yv-form-row">
                <label>Name</label>
                <input
                  type="text"
                  value={editForm.name}
                  onChange={(e) => handleEditChange("name", e.target.value)}
                  required
                />
              </div>

              <div className="yv-form-row">
                <label>Relation</label>
                <input
                  type="text"
                  value={editForm.relation}
                  onChange={(e) =>
                    handleEditChange("relation", e.target.value)
                  }
                  required
                />
              </div>

              <div className="yv-form-grid">
                <div className="yv-form-row">
                  <label>Age</label>
                  <input
                    type="number"
                    value={editForm.age}
                    onChange={(e) => handleEditChange("age", e.target.value)}
                    required
                  />
                </div>

                <div className="yv-form-row">
                  <label>Qualification</label>
                  <input
                    type="text"
                    value={editForm.qualification}
                    onChange={(e) =>
                      handleEditChange("qualification", e.target.value)
                    }
                    required
                  />
                </div>
              </div>

              <div className="yv-form-grid">
                <div className="yv-form-row">
                  <label>Amount</label>
                  <input
                    type="text"
                    value={editForm.amount}
                    onChange={(e) =>
                      handleEditChange("amount", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="yv-form-row">
                  <label>Status</label>
                  <select
                    value={editForm.status}
                    onChange={(e) =>
                      handleEditChange("status", e.target.value)
                    }
                  >
                    <option>Approved</option>
                    <option>Pending</option>
                  </select>
                </div>
              </div>

              <div className="yv-form-grid">
                <div className="yv-form-row">
                  <label>Village</label>
                  <input
                    type="text"
                    value={editForm.village}
                    onChange={(e) =>
                      handleEditChange("village", e.target.value)
                    }
                    required
                  />
                </div>

                <div className="yv-form-row">
                  <label>Mandal</label>
                  <select
                    value={editForm.mandal}
                    onChange={(e) =>
                      handleEditChange("mandal", e.target.value)
                    }
                  >
                    <option>Kandukur</option>
                    <option>Gudluru</option>
                    <option>Ulavapadu</option>
                  </select>
                </div>
              </div>

              <div className="yv-form-row">
                <label>Date</label>
                <input
                  type="text"
                  placeholder="DD-MM-YYYY"
                  value={editForm.date}
                  onChange={(e) => handleEditChange("date", e.target.value)}
                  required
                />
              </div>

              <div className="yv-modal-actions">
                <button
                  type="button"
                  className="yv-modal-cancel-btn"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="yv-modal-save-btn">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminYuvagalamTable;